import type { Dispatch, SetStateAction } from "react";
import type { FormType } from "../../components/types";

import { getAvailablePairingFormControls } from "./getAvailablePairingFormControls";

export const addEmptyPairingForm = (
  forms: FormType[],
  setForms: Dispatch<SetStateAction<FormType[]>>,
) => {
  if (forms.length < 3) {
    const availableControls = getAvailablePairingFormControls(forms);
    setForms(state => {
      const result = [
        ...state,
        {
          control: availableControls[0],
          include: [],
          excludes: [],
        },
      ];
      return result;
    });
  }
};
